export const LOGO_URL_LIGHT = "https://customer-assets-lxgj4vgw.emergentagent.net/job_afc-mobile-hub/artifacts/9jda1ajr_ChatGPT%20Image%20Sep%204%2C%202026%2C%2005_04_33%20AM.png";
export const LOGO_URL_DARK = "https://customer-assets-lxgj4vgw.emergentagent.net/job_afc-mobile-hub/artifacts/klessua9_ChatGPT%20Image%20Sep%204%2C%202026%2C%2005_04_54%20AM.png";
export const LOGO_URL = LOGO_URL_LIGHT;

export const CATEGORIES_PHONES = [
  { id: "all", en: "All Phones", ar: "كل الهواتف" },
  { id: "iphone", en: "iPhone", ar: "آيفون" },
  { id: "samsung", en: "Samsung", ar: "سامسونج" },
  { id: "other_phone", en: "Other Brands", ar: "علامات أخرى" },
];

export const CATEGORIES_ACCESSORIES = [
  { id: "all", en: "All", ar: "الكل" },
  { id: "chargers", en: "Chargers", ar: "شواحن" },
  { id: "cables", en: "Cables", ar: "كابلات" },
  { id: "earbuds", en: "Earbuds", ar: "سماعات" },
  { id: "cases", en: "Cases", ar: "أغلفة" },
  { id: "power_banks", en: "Power Banks", ar: "بطاريات محمولة" },
  { id: "smart_watches", en: "Smart Watches", ar: "ساعات ذكية" },
  { id: "other_accessory", en: "Other", ar: "أخرى" },
];

export const CURRENCY_RATES = {
  // Base is AED
  AED: 1,
  USD: 0.272,   // 1 AED ≈ 0.272 USD
  IQD: 356.6,   // 1 AED ≈ 356.6 IQD
};
